export default __webpack_public_path__ + "static/media/glitch003.70ef4cea.png";